import { useState, createContext } from 'react';

const defaultValues = {
    open: false,
    message: '',
    severity: 'info',
    showNotification: () => {},
    hideNotification: () => {}
}

export const NotificationContext = createContext(defaultValues);

const NotificationProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('info');
    const [autoHideDuration, setAutoHideDuration] = useState(5000);

    const showNotification = (message, severity = 'info', duration = 5000) => {
        setMessage(message);
        setSeverity(severity);
        setAutoHideDuration(duration);
        setOpen(true);
    };

    const hideNotification = () => {
        setOpen(false);
    };

    const tools = {
        open,
        message,
        severity,
        autoHideDuration,
        showNotification,
        hideNotification
    };

    return <NotificationContext.Provider value={tools}>{children}</NotificationContext.Provider>;
};

export default NotificationProvider;
